// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--wQDhY","link":"_93444fe79c--link--3ruIo","icon":"_93444fe79c--icon--2r99s","remoteness":"_93444fe79c--remoteness--1BnAC"};